<template>
    <!--滑动banner -->
    <div class="swiperbanner_container">
  
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide>
          <li class="ub ub-ver main-block" v-for="(item, index) in gift_1" :key="index">
            <div class="ub gift-block">
              <li class="ub ub-pc ub-ver gift-item ub-f1" v-for="sub_item in item" :key="sub_item.id" @click="chosedGift(sub_item)" :class="chosed == sub_item.id ? 'on' : ''">
                <div style="border:0px solid red; border-radius:.2em;">
                  <img :src="sub_item.url" class="gift-picture" />
                </div>
  
                <div class="gift-name">{{sub_item.name}}</div>
                <div class="gift-coin">{{sub_item.coin}}金币</div>
              </li>
            </div>
          </li>
        </swiper-slide>
  
        <swiper-slide>
          <li class="ub ub-ver main-block" v-for="(item, index) in gift_2" :key="index">
            <div class="ub gift-block">
              <li class="ub ub-pc ub-ver gift-item ub-f1" v-for="sub_item in item" :key="sub_item.id" @click="chosedGift(sub_item)" :class="chosed == sub_item.id ? 'on' : ''">
                <div>
                  <img :src="sub_item.url" class="gift-picture" />
                </div>
  
                <div class="gift-name">{{sub_item.name}}</div>
                <div class="gift-coin">{{sub_item.coin}}金币</div>
              </li>
            </div>
          </li>
        </swiper-slide>
  
        <div class="swiper-pagination" slot="scrollbar"></div>
      </swiper>

      <div class=" gift-receiver ub ub-pc ub-ac2">
        <div class="ub ub-pc">
            <span class="gift-lable1">{{ tips }}</span>
        </div>
        <div class="btn"  @click="select_gift(chosed_gift)">
            <span>确定</span>
        </div>
      </div>
      <alert ref="myConfirm_setGift" @userBehavior="formact_setGift"></alert>
    </div>
  </template>
  
  <script>
  import * as tool from "../api/common";
  import { mapMutations, mapActions } from "vuex";
  import Alert from "../components/Alert.vue";
  export default {
    name: "Swiper_Gift",
    props: {
      uid: String
    },
    components: {
      alert: Alert,
    },
    data() {
      return {
        gift_1: [],
        gift_2: [],

        swiperOption: {
          direction: "horizontal",
  
          observeParents: true, //观察父组件，当父组件变化时，自己随着变化
          observer: true, //观察自己，自己的参数变化时，更新
          centeredSlides: true, //设置为true时，活动块居中显示，默认下居左显示
          loop: false, //滑动过程中会在前后复制多个slider,效果看起来是循环的
          loopedSlides: 3, //设置滑动过程中所要用到的loop个数
          slidesPerView: "auto", //同时显示的slide数量
          loopAdditionalSlides: 100,
          autoPlay: {
            delay: 3000,
            disableOnInteraction: false, //鼠标移动上去时是否继续播放
          },
          pagination: { el: ".swiper-pagination" },
          paginationType: "bullets",
          paginationElement: "span",
        },
  
        pre_send_time: new Date(),
        chosed: 0,
        chosed_gift: {
          id: 0,
          coin: 0,
          name: "",
          url: "",
        },
        tips: ""
      };
    },
    mounted() {
      this.init_page();
    },
    methods: {
      ...mapMutations(["get", "post"]), //引入方法
      ...mapActions(["act_get_userinfo", "act_reload_userinfo"]), //引入方法

      chosedGift(item) {
        this.chosed_gift = item;
        this.chosed = item.id;
        this.tips = "当前礼物为"+item.name+"，对方查看相册时需赠送此礼物";
        if (item.score >= 10000) {
          this.$refs.myConfirm_setGift.show('当前礼物为'+item.name+'，此礼物过于贵重，为提高赠送概率请适当设定礼物哦', {
            type: 'alert',
            confirmText: '确定',
            titleText: '温馨提示',
            data: item
          });
        }
      },
      init_page() {
        var const_data = this.$store.state.const_data;
        this.gift_1 = tool.slice_arry(const_data.gift_1, 4);
        this.gift_2 = tool.slice_arry(const_data.gift_2, 4);
        this.get_setGift();
      },

      get_setGift() {
        var uid = this.$store.state.uid;
        var self = this;
        var uid_from = "wx_UH2Z1YZ9ZBSPW7L5";
        if (this.$store.state.url == "http://appdata.jscx666.cn") {
          var uid_from = "wx_1BH9UIZDAULXHIND";
        }
        self.get({
          url: "/App/Get_UserRight/?uid_from="+ uid_from + "&uid_to=" + uid ,
          success: function (data) {
              var album_gift = Number(data.album_gift);
              if (album_gift !== "") {
                var const_data = self.$store.state.const_data;
                var chosed_gift = const_data.gift_2.filter(item => item.coin === album_gift);
                if (chosed_gift.length <= 0) {
                  chosed_gift = const_data.gift_1.filter(item => item.coin === album_gift);
                }
                if (chosed_gift.length > 0) {
                  self.chosed_gift = chosed_gift[0];
                  self.chosed = chosed_gift[0].id;
                  self.tips = "当前礼物为"+chosed_gift[0].name+"，对方查看相册时需赠送此礼物";
                }

                if (album_gift >= 10000) {
                  self.$refs.mySwiper.swiper.slideTo(1);
                }
              } else {
                self.chosed_gift = self.gift_1[0][0];
                self.chosed = self.gift_1[0][0].id;
                self.tips = "当前礼物为"+chosed_gift[0][0].name+"，对方查看相册时需赠送此礼物";
              }
          },
        });

        
      },

      select_gift(item) {
        if (item.name !== "") {
            var album_gift = this.chosed_gift.coin;
            var send_data = { album_gift: album_gift };
            this.save_serve(send_data, this.uid);
        } else {
            this.$toast.center("请先选择礼物~")
        }
      },

      save_serve(send_data,uid) {
        //后台保存信息
        var self = this;
        //var send_data = {'nick' : nick};
        var data = {
          url: "/App/User_ModifyBaseInfo",
          data: {
            uid: uid,
            data: JSON.stringify(send_data),
          },
          success: function (data_serve) {
            if (data_serve.state == "1") {
              self.$emit("gift_hidden");
              self.$toast.center("设置成功");
            }
          },
        };
        self.post(data);
      },

      formact_setGift (type, data) {
        if (type == 'clickConfirm') {
          this.chosed_gift = data;
          this.chosed = data.id;
        }
    },
    },
  };
  </script>
  
  <style lang="scss" scoped>

  .swiperbanner_container {
    padding-top: 1rem;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #333;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    .swiper-pagination {
      bottom: 2px !important;
    }
  }
  
  
  .main-block {
    background-color: #333;
    .gift-block {
      padding: 0.2rem 0;
      justify-content: space-around;
      .on {
        border: 1px solid #8A61FF;
        border-radius: 0.5rem;
      }
      .gift-item {
        width: 4rem;
        margin: 0 1rem;
        .gift-picture {
          height: 3.5rem;
          width: 3rem;
          padding: 0.1rem;
        }
        
        .gift-name {
          margin-top: 0.2rem;
          font-size: 0.8rem;
          color: #fff;
        }
        
        .gift-coin {
          font-size: 0.6rem;
          color: #959595;
          margin-top: 0.2rem;
        }
      }
    }
  }
  
  .gift-receiver {
    padding: 0.5rem 1.5rem;
    background-color: #333;
    .gift-lable1 {
      font-size: 0.75rem;
      color: #fff;
    }
    .btn {
        padding: 0.3rem 1rem;
        background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
        border-radius: 1rem;
        span {
            font-size: 0.9rem;
            font-weight: bold;
            color: #fff;
        }
    }
  }
  
  </style>